export type ReportFormTypeZero = 0;
export type ReportFormTypeOne = 1;
export type ReportFormTypeTwo = 2;
export type ReportFormTypeThree = 3;
export type ReportFormTypeFour = 4;
export type ReportFormTypeFive = 5;
export type ReportFormTypeEoOne = 6;
export type ReportFormTypeEoOneAAssets = 7;
export type ReportFormTypeEoOneALiabilities = 8;
export type ReportFormTypeEoOneB = 9;
export type ReportFormTypeEoTen = 10;
export type ReportFormTypeSixteen = 16;
export type ReportFormTypeOneThroughFour = ReportFormTypeOne | ReportFormTypeTwo | ReportFormTypeThree | ReportFormTypeFour;
export type ReportFormType = ReportFormTypeZero | ReportFormTypeOneThroughFour | ReportFormTypeFive;
export type ReportFormTypeEo = ReportFormTypeEoOne | ReportFormTypeEoOneAAssets | ReportFormTypeEoOneALiabilities | ReportFormTypeEoOneB | ReportFormTypeEoTen | ReportFormTypeSixteen;

export const FormTypeId = {
  FormZero: 0,
  FormOne: 1,
  FormTwo: 2,
  FormThree: 3,
  FormFour: 4,
  FormFive: 5,
  FormEoOne: 6,
  FormEoOneAAssets: 7,
  FormEoOneALiabilities: 8,
  FormEoOneB: 9,
  FormTen: 10,
  FormEleven: 11,
  FormTwelve: 12,
  FormThirteen: 13,
  FormFourteen: 14,
  FormFifteen: 15,
  FormSixteen: 16,
  FormSeventeen: 17,
  FormEighteen: 18,
  FormNineteen: 19,
  FormTwenty: 20,
  FormZeroJson: 21,
  FormOneJson: 22,
  FormTwoJson: 23,
  FormFourJson: 24,
  FormFiveJson: 25,
  FormOneThroughFour: (id: number): id is ReportFormTypeOneThroughFour => OneThroughFourFormTypes.includes(id as (typeof OneThroughFourFormTypes)[number]),
  isEconomyAopForm: (id: number): id is ReportFormTypeEo => EoAopFormTypes.includes(id as (typeof EoAopFormTypes)[number]),
  isBudgetForm: (id: number): id is ReportFormTypeZero => BudgetFormTypes.includes(id as (typeof BudgetFormTypes)[number])
} as const;

export const OneThroughFourFormTypes = [
  FormTypeId.FormOne,
  FormTypeId.FormTwo,
  FormTypeId.FormThree,
  FormTypeId.FormFour
] as const;

export const EoAopFormTypes = [
  FormTypeId.FormEoOne,
  FormTypeId.FormEoOneAAssets,
  FormTypeId.FormEoOneALiabilities,
  FormTypeId.FormEoOneB,
  FormTypeId.FormSixteen
] as const;

export const DecimalScaleFormTypes = [
  FormTypeId.FormTen,
  FormTypeId.FormEleven,
  FormTypeId.FormTwelve,
  FormTypeId.FormThirteen,
  FormTypeId.FormFourteen,
  FormTypeId.FormFifteen,
  FormTypeId.FormSeventeen,
  FormTypeId.FormEighteen,
  FormTypeId.FormNineteen
] as const;

export const MilionScaleFormTypes = [
  FormTypeId.FormTwenty
] as const;

export const PjfiFormTypes = [
  FormTypeId.FormEoOne,
  FormTypeId.FormEoOneAAssets,
  FormTypeId.FormEoOneALiabilities,
  FormTypeId.FormEoOneB,
  FormTypeId.FormTen,
  FormTypeId.FormEleven,
  FormTypeId.FormTwelve,
  FormTypeId.FormThirteen,
  FormTypeId.FormFourteen,
  FormTypeId.FormFifteen
] as const;

export const BudgetFormTypes = [
  FormTypeId.FormZero,
  FormTypeId.FormOne,
  FormTypeId.FormTwo,
  FormTypeId.FormThree,
  FormTypeId.FormFour,
  FormTypeId.FormFive,
  FormTypeId.FormZeroJson,
  FormTypeId.FormOneJson,
  FormTypeId.FormTwoJson,
  FormTypeId.FormFourJson,
  FormTypeId.FormFiveJson
] as const;

export type MilionScaleFormType = (typeof MilionScaleFormTypes)[number];

export type DecimalScaleFormType = (typeof DecimalScaleFormTypes)[number];

export const EoFormThreeTotalId = 15;

export enum FormTypeValue {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  ELEVEN = 11,
  TWELVE = 12,
  THIRTEEN = 13,
  FOURTEEN = 14
}

export enum BudgetJsonFormTypeLabel {
  BS = 'БС',
  PR = 'ПР',
  NT = 'НТ',
  IB = 'ИБ'
}

export const FormTypeNo = {
  [FormTypeId.FormZero]: FormTypeValue.ONE,
  [FormTypeId.FormOne]: FormTypeValue.ONE,
  [FormTypeId.FormTwo]: FormTypeValue.TWO,
  [FormTypeId.FormThree]: FormTypeValue.THREE,
  [FormTypeId.FormFour]: FormTypeValue.FOUR,
  [FormTypeId.FormFive]: FormTypeValue.FIVE,
  [FormTypeId.FormEoOne]: FormTypeValue.ONE,
  [FormTypeId.FormEoOneAAssets]: FormTypeValue.TWO,
  [FormTypeId.FormEoOneALiabilities]: FormTypeValue.TWO,
  [FormTypeId.FormEoOneB]: FormTypeValue.THREE,
  [FormTypeId.FormTen]: FormTypeValue.FOUR,
  [FormTypeId.FormEleven]: FormTypeValue.FIVE,
  [FormTypeId.FormTwelve]: FormTypeValue.SIX,
  [FormTypeId.FormThirteen]: FormTypeValue.SEVEN,
  [FormTypeId.FormFourteen]: FormTypeValue.EIGHT,
  [FormTypeId.FormFifteen]: FormTypeValue.NINE,
  [FormTypeId.FormSixteen]: FormTypeValue.TEN,
  [FormTypeId.FormSeventeen]: FormTypeValue.ELEVEN,
  [FormTypeId.FormEighteen]: FormTypeValue.TWELVE,
  [FormTypeId.FormNineteen]: FormTypeValue.THIRTEEN,
  [FormTypeId.FormTwenty]: FormTypeValue.FOURTEEN,
  [FormTypeId.FormZeroJson]: BudgetJsonFormTypeLabel.BS,
  [FormTypeId.FormOneJson]: BudgetJsonFormTypeLabel.BS,
  [FormTypeId.FormTwoJson]: BudgetJsonFormTypeLabel.PR,
  [FormTypeId.FormFourJson]: BudgetJsonFormTypeLabel.NT,
  [FormTypeId.FormFiveJson]: BudgetJsonFormTypeLabel.IB
} as const;
